<template>
  <div>
    <NuxtLoadingIndicator color="#0065a6" :height="3" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
